export class ConfiguracionTarjetaInicio {
    constructor(
        public id: string,
        public titulo: string,
        public subtitulo: string,
        public cantidad: number,
        public ruta: Ruta,
        public requiereAccion: boolean
    ) {
        this.titulo = titulo;
        this.subtitulo = subtitulo;
        this.cantidad = cantidad;
        this.ruta = ruta;
        this.requiereAccion = requiereAccion;
    }
}

interface Ruta {
    nombre: string;
    url: string;
    queryParams?: any;
}
